<template>
    <div>
        <div v-if="!initial_request">
            <g-typography tag="h3" font-weight="semibold">Request Data Removal</g-typography>
            <g-typography class="g-mt-3 g-mb-5" tag="p" color="grey-6">
                We store information such as your email address, shipping address, and phone number as part of our
                sponsorship programs. If you would like us to remove this information, you can request we do so below.
            </g-typography>
            <g-button shape="round" theme="live" @click="initial_request = true">
                <g-typography font-weight="semibold">Request Removal</g-typography>
            </g-button>
        </div>
        <div v-if="initial_request && !request_completed" class="mt-15">
            <g-typography tag="h4" font-weight="semibold">Are you sure?</g-typography>
            <g-typography class="g-mt-3 g-mb-5" tag="p" color="grey-6">
                By requesting your data to be removed, your personally identifiable information will be removed from any
                account you have or are currently working with. You will no longer be able to receive product shipments,
                payments or any communications.
            </g-typography>

            <g-button
                class="button is-danger"
                :disabled="$root.loading('profile.request.data.removal')"
                shape="round"
                theme="live"
                @click="confirmRequest"
            >
                <g-typography font-weight="semibold" color="white">Confirm Request</g-typography>
            </g-button>
            <g-button shape="round" theme="live" @click="initial_request = false">
                <g-typography font-weight="semibold">Cancel</g-typography>
            </g-button>
        </div>
        <div v-if="initial_request && request_completed">
            Your request to remove your data has been sent, we will comply with your request within 30 days. You can
            cancel your request below.
            <div class="mt-15">
                <g-button
                    class="button is-danger"
                    :disabled="$root.loading('profile.request.data.cancel')"
                    shape="round"
                    theme="live"
                    @click="cancelRequest"
                >
                    <g-typography font-weight="semibold" color="white">Cancel Request</g-typography>
                </g-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        /**
         * The component name
         *
         * @type {string}
         */
        name: 'RequestRemoval',

        /**
         * The component data
         *
         * @returns {object}
         */
        data() {
            return {
                /**
                 * The initial request button boolean
                 *
                 * @type {boolean}
                 */
                initial_request: false,

                /**
                 * The request has completed
                 *
                 * @type {boolean}
                 */
                request_completed: false
            };
        },

        /**
         * The component methods
         *
         * @type {object}
         */
        methods: {
            /**
             * Handle the confirmed request
             */
            confirmRequest() {
                this.$root.loaderStart('profile.request.data.removal');
                this.$http.post(`/contact/${this.$root.contact_id}/request/data/confirm`).then(
                    () => {
                        this.$root.loaderStop('profile.request.data.removal');
                        this.request_completed = true;
                    },
                    () => {
                        this.$root.loaderStop('profile.request.data.removal');
                    }
                );
            },

            /**
             * Handle the confirmed request
             */
            cancelRequest() {
                this.$root.loaderStart('profile.request.data.cancel');
                this.$http.post(`/contact/${this.$root.contact_id}/request/data/cancel`).then(
                    () => {
                        this.$root.loaderStop('profile.request.data.cancel');
                        this.initial_request = false;
                        this.request_completed = false;
                    },
                    () => {
                        this.$root.loaderStop('profile.request.data.cancel');
                        this.initial_request = false;
                        this.request_completed = false;
                    }
                );
            }
        },

        /**
         * When the component is first created
         *
         * @type {function}
         */
        created() {
            if (this.$root.contact.requested_data_removal) {
                this.initial_request = true;
                this.request_completed = true;
            }
        }
    };
</script>
